import { render, staticRenderFns } from "./view-layout.vue?vue&type=template&id=3e8d4167&scoped=true"
import script from "./view-layout.vue?vue&type=script&lang=js"
export * from "./view-layout.vue?vue&type=script&lang=js"
import style0 from "./view-layout.vue?vue&type=style&index=0&id=3e8d4167&prod&lang=scss"
import style1 from "./view-layout.vue?vue&type=style&index=1&id=3e8d4167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8d4167",
  null
  
)

export default component.exports